import cn from 'classnames';
import styles from './badge.module.scss';

interface IBadgeProps {
  isActive: boolean,
  color: string,
  text: string,
}

const Badge = ({ isActive, color, text }: IBadgeProps) => (
  <span
    className={ cn(styles.badge, { [styles.active]: isActive, [styles.inactive]: !isActive }) }
    style={ { '--product-color': color } as React.CSSProperties }
  >
    <span className={ styles.label }>
      { text }
    </span>
  </span>
);

export default Badge;
